import styled from 'styled-components';

export const Container = styled.div`

`;

export const SuccessContainer = styled.div`
  height: 268px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    margin-bottom: 24px;
  }

  h3 {
    margin: 0;
    font-size: 16px;
    margin-top: 24px;
  }

  p {
    line-height: 28px;
  }
`;
